import { inject, injectable } from 'inversify'
import symbols from '../../symbols'
import {
  IAppErrorFactory,
  IQuestionsService,
  IVoteForChoiceUseCase,
  VoteForChoiceUseCaseInput,
  VoteForChoiceUseCaseOutput,
} from '../../types'

@injectable()
export default class VoteForChoiceInteractor implements IVoteForChoiceUseCase {
  @inject(symbols.IQuestionsService) private questionsService: IQuestionsService

  @inject(symbols.IAppErrorFactory) private errorFactory: IAppErrorFactory

  async handle(input: VoteForChoiceUseCaseInput): Promise<VoteForChoiceUseCaseOutput> {
    const output = this.getDefaultOutputData()
    try {
      output.choice = await this.questionsService.voteForChoice(input)
    } catch (e) {
      output.error = this.errorFactory.create({
        originalInstance: e as Error,
      })
    }

    return output
  }

  private getDefaultOutputData(): VoteForChoiceUseCaseOutput {
    return {
      choice: null,
      error: null,
    }
  }
}
